import '@/assets/styles.scss';
import '@/assets/tailwind.css';
import Aura from '@primevue/themes/aura';
import PrimeVue from 'primevue/config';
import { definePreset } from '@primevue/themes';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import DialogService from 'primevue/dialogservice';
import { redirectToLogin } from './auth/redirectToKeycloak';
import { exchangeCodeForToken } from './auth/tokenService';
import { fetchUserProfile } from './auth/userService';

const initApp = () => {
    const app = createApp(App);
    const pinia = createPinia();

    pinia.use(
        createPersistedState({
            storage: localStorage,
            key: (id) => `xai-dash__persisted__${id}`,
            debug: import.meta.env.MODE === 'development'
        })
    );

    app.use(router);
    // app.use(PrimeVue, {
    //     theme: {
    //         preset: Aura,
    //         options: {
    //             darkModeSelector: '.app-dark'
    //         }
    //     }
    // });
    const ATLANTIS_THEME = definePreset(Aura, {
        semantic: {
            primary: {
                50: '#FFF4E6',
                100: '#FFE4BF',
                200: '#FFD199',
                300: '#FFBA73',
                400: '#FFA14D',
                500: '#F28705',
                600: '#D77404',
                700: '#B95F03',
                800: '#994C02',
                900: '#7A3B01',
                950: '#4D2400'
            }
        }
    });

    app.use(PrimeVue, {
        theme: {
            preset: ATLANTIS_THEME,
            options: {
                darkModeSelector: '.app-dark'
            }
        }
    });
    app.directive('tooltip', Tooltip);
    app.use(ToastService);
    app.use(ConfirmationService);
    app.use(pinia);
    app.use(DialogService);
    app.mount('#app');
};

const bootstrap = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (!code) {
        redirectToLogin();
        return;
    }

    try {
        const { access_token } = await exchangeCodeForToken(code);
        const user = await fetchUserProfile(access_token);
        if (import.meta.env.MODE === 'development') console.log('Authenticated user:', user);
        initApp();
    } catch (err) {
        redirectToLogin();
    }
};

// bootstrap();
initApp();
